import { Card, CardBody, CardHeader, CardImage, CardTitle } from '@progress/kendo-react-layout';
import ClickableDiv from 'common/components/clickableDiv/ClickableDiv';
import { sanitizeHtml } from 'common/utils/sanitize';

interface PowerpointOptionProps {
  title: string;
  description: string;
  image: string;
  onClick: () => void;
}

function Option({ image, title, description, onClick }: Readonly<PowerpointOptionProps>) {
  return (
    <ClickableDiv onClick={onClick}>
      <Card orientation="horizontal">
        <CardImage src={image} />
        <div className="k-vbox">
          <CardHeader>
            <CardTitle>{title}</CardTitle>
          </CardHeader>
          <CardBody>
            {/* eslint-disable-next-line react/no-danger -- Sanitized with DOMPurify */}
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }} />
          </CardBody>
        </div>
      </Card>
    </ClickableDiv>
  );
}

export default Option;
